import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import get from 'lodash/get';

import {LoadRow} from '../../LoadRow';
import Spinner from '~/components/common/Spinner';
import * as actionCreators from '~/modules/backhaul/actions';
import mapDispatch from '~/misc/mapDispatch';
import backhaulIdentity from '~/modules/backhaul/backhaulIdentity';
import Point from '~/components/common/DirectionPoint/index.js';

import css from './index.css';

const LocationName = ({address}) => {
  if (!address || (!address.city && !address.state)) {
    return (
      <span className={css.locationBlock}>
        <span className={css.special}>Anywhere</span>
      </span>
    );
  }

  if (!address.city) {
    return (
      <span className={css.locationBlock}>
        <span className={css.locationCity}>
          <span className={css.special}>Anywhere in</span>
        </span>
        <span className={css.locationState}>
          {address.state}
        </span>
      </span>
    );
  }

  return (
    <span className={css.locationBlock}>
      <span className={css.locationCity}>
        {address.city.toLowerCase()}{', '}
      </span>
      <span className={css.locationState}>
        {address.state}
      </span>
    </span>
  );
};

const Link = ({url, view, active, children}) => (
  <span className={css.columnLink}>
    ({(active)
      && <a href={url} className={css.link} target='_blank' onClick={view}>{children}</a>})
  </span>
);

const BackhaulDirection = connect((state, props) => ({
  loadsResource: get(state, ['resources', 'byName', props.loadsIdentity.name, props.loadsIdentity.key]),
}), mapDispatch({
  view: ({identity}) => actionCreators.viewBackhaulLane(identity),
}))(({query, formQuery, loadsResource, active, url, view}) => {
  const totalCount = get(loadsResource, 'item.total_shipments');
  const loading = get(loadsResource, 'loading');
  const item = get(loadsResource, 'item');
  return (
    <div>
      <div className={css.directionWrap}>
        <div className={cs(css.directionTitle, {
          [css.allowBreak]: true,
        })}
        >
          <span className={css.columnCount}>{
            loading
              ? <span className={css.spinner}><Spinner scalable={true}/></span>
              : totalCount
          }</span>
          <Link url={url} view={view} active={true}>View loads</Link>

          <span className={css.laneLocation}>
            <span
              className={css.columnDeadhead}
              title='Pickup deadhead'
            >
              {query.pick_up.deadhead} {parseInt(query.pick_up.deadhead) && 'mi'}
            </span>
            <span className={cs(css.columnLocationName, css.columnPickup)}>
              <Point
                title='Destination'
                text={'B'}
              />
              <LocationName address={query.pick_up.description}/>
            </span>
            <span className={css.arrow}>→</span>
            <span className={css.columnLocationName}>
              <LocationName address={(query.drop_off && query.drop_off.description)}/>
            </span>
          </span>

        </div>
      </div>

      {active && (
        <div className={css.loadsList}>
          {item && item.shipments.map(load => <LoadRow key={load.id} load={load} query={formQuery}/>)}
        </div>
      )}
    </div>
  );
});

const Backhaul = ({backhaul: {lists}, active}) => (
  <div
    className={cs('qa-backhaul', css.container)}
  >
    <div className={css.header}>
      <div className={css.title}>
        Backhaul loads
      </div>
    </div>

    <div className={css.directionsList}>
      {lists && lists[0]
        && lists[0].map(item => <BackhaulDirection {...item} active={active} key={item.identity.shortkey} />)}
    </div>
  </div>
);

export default connect(({backhaul}, {loadIdentity}) => {
  const identity = backhaulIdentity(loadIdentity);

  return {
    backhaul: backhaul.index[identity.key] || {},
    active: backhaul.active[identity.key],
  };
})(Backhaul);



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/Backhaul/index.js